"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var antd_1 = require("antd");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TabEditorContainer_1 = require("../../../../../../shared/components/containers/TabEditorContainer");
var BrandSmsCfgEditor = /** @class */ (function (_super) {
    __extends(BrandSmsCfgEditor, _super);
    function BrandSmsCfgEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_restrictions = "additional";
        _this.columns = [
            {
                title: 'Тип смс сообщения',
                dataIndex: _this.props.dataRestrictions.dk_sms_action_type_title,
                key: _this.props.dataRestrictions.dk_sms_action_type_title,
                width: 200,
            }, {
                title: 'Совершенных попыток',
                dataIndex: _this.props.dataRestrictions.dk_completed_attempts_count,
                key: _this.props.dataRestrictions.dk_completed_attempts_count,
                align: "center",
                width: 200,
            }, {
                title: 'Блокировка, минут',
                dataIndex: _this.props.dataRestrictions.dk_block_by_minutes,
                key: _this.props.dataRestrictions.dk_block_by_minutes,
                align: "center",
                width: 200,
            }, {
                title: 'Ограничение активно',
                dataIndex: _this.props.dataRestrictions.dk_is_locked,
                key: _this.props.dataRestrictions.dk_is_locked,
                render: function (text, record, idx) {
                    if (record.is_locked) {
                        return (React.createElement("div", null, "\u041D\u0415\u0422"));
                    }
                    else {
                        return (React.createElement("div", null, "\u0414\u0410"));
                    }
                },
                align: "center",
                width: 200,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 100
            }
        ];
        return _this;
    }
    BrandSmsCfgEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_RL = this.props.dataRestrictions.Subscribe("*", function (id, data) {
            _this.setState({ restrictions_list: data.data });
        });
        this.SID_SA = this.props.listSmsTemplateActions.Subscribe("*", function (id, data) {
            _this.setState({
                _actions: data.data
            });
        });
        if (this.props.record != null) {
            this.props.data.LoadData(this.props.record.key, function () {
                _this.setState({
                    sms_api_url: _this.props.data.DATA.sms_api_url,
                    sms_api_key: _this.props.data.DATA.sms_api_key,
                    sms_login: _this.props.data.DATA.sms_login,
                    sms_password: _this.props.data.DATA.sms_password,
                    sms_provider_type_code: _this.props.data.DATA.sms_provider_type_code,
                    sms_provider_type_title: _this.props.data.DATA.sms_provider_type_title,
                    is_limit_sms_by_single_ip: _this.props.data.DATA.is_limit_sms_by_single_ip,
                    limit_sms_count_short: _this.props.data.DATA.limit_sms_count_short,
                    limit_sms_interval_min_short: _this.props.data.DATA.limit_sms_interval_min_short,
                    limit_sms_count_long: _this.props.data.DATA.limit_sms_count_long,
                    limit_sms_interval_min_long: _this.props.data.DATA.limit_sms_interval_min_long,
                    restrictions_list: _this.props.dataRestrictions.DATA.data,
                    allow_registration_by_phone: _this.props.data.DATA.allow_registration_by_phone,
                    _actions: [],
                    tab_key: _this.key_main
                });
            });
        }
        this.setState({
            sms_api_url: "",
            sms_api_key: "",
            sms_login: "",
            sms_password: "",
            sms_provider_type_code: 0,
            sms_provider_type_title: "",
            is_limit_sms_by_single_ip: false,
            limit_sms_count_short: 1,
            limit_sms_interval_min_short: 5,
            limit_sms_count_long: 5,
            limit_sms_interval_min_long: 60,
            restrictions_list: [],
            _actions: [],
            allow_registration_by_phone: false,
            tab_key: this.key_main
        });
        this.doReSetRules();
        this.props.state.setExtBreadCrumbPath(["Настройка SMS бренда"]);
        this.props.listSmsTemplateActions.LoadData();
        this.props.dataRestrictions.LoadData(this.props.record.key);
    };
    BrandSmsCfgEditor.prototype.componentWillUnmount = function () {
        this.props.dataRestrictions.UnSubscribe(this.SID_RL);
        this.props.listSmsTemplateActions.UnSubscribe(this.SID_SA);
    };
    BrandSmsCfgEditor.prototype.doReSetRules = function () {
        this.setState({
            sms_api_url_rules: { isError: false },
            sms_api_key_rules: { isError: false },
            sms_login_rules: { isError: false },
            sms_password_rules: { isError: false },
            sms_provider_type_rules: { isError: false },
            limit_sms_count_short_rules: { isError: false },
            limit_sms_interval_min_short_rules: { isError: false },
            limit_sms_count_long_rules: { isError: false },
            limit_sms_interval_min_long_rules: { isError: false }
        });
    };
    BrandSmsCfgEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        /* if ((!this.state.sms_api_url) || (this.state.sms_api_url.length === 0)) {
             this.setState({ sms_api_url_rules: { isError: true, errorMessage: "Поле [url sms сервер] не заполнено!" } })
             return false;
         }
         if ((!this.state.sms_api_key) || (this.state.sms_api_key.length === 0)) {
             this.setState({ sms_api_key_rules: { isError: true, errorMessage: "Поле [api ключ] не заполнено!" } })
             return false;
         }
 
         if ((!this.state.sms_login) || (this.state.sms_login.length === 0)) {
             this.setState({ sms_login_rules: { isError: true, errorMessage: "Поле [логин sms] не заполнено!" } })
             return false;
         }
         if ((!this.state.sms_password) || (this.state.sms_password.length === 0)) {
             this.setState({ sms_password_rules: { isError: true, errorMessage: "Поле [пароль sms] не заполнено!" } })
             return false;
         }*/
        if ((this.state.sms_provider_type_code <= 0) || (this.state.sms_provider_type_title.length === 0)) {
            this.setState({ sms_provider_type_rules: { isError: true, errorMessage: "Поле [тип провайдера] не выбрано!" } });
            return false;
        }
        if (this.state.limit_sms_count_short < 1) {
            this.setState({ limit_sms_count_short_rules: { isError: true, errorMessage: "Поле [количество sms] не заполнено!" } });
            return false;
        }
        if (this.state.limit_sms_interval_min_short < 1) {
            this.setState({ limit_sms_interval_min_short_rules: { isError: true, errorMessage: "Поле [интервал, минут] не заполнено!" } });
            return false;
        }
        if (this.state.limit_sms_count_long < 1) {
            this.setState({ limit_sms_count_long_rules: { isError: true, errorMessage: "Поле [количество sms] не заполнено!" } });
            return false;
        }
        if (this.state.limit_sms_interval_min_long < 1) {
            this.setState({ limit_sms_interval_min_long_rules: { isError: true, errorMessage: "Поле [интервал, минут] не заполнено!" } });
            return false;
        }
        return true;
    };
    BrandSmsCfgEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                brand_id: this.props.record.key,
                sms_api_url: this.state.sms_api_url,
                sms_api_key: this.state.sms_api_key,
                sms_login: this.state.sms_login,
                sms_password: this.state.sms_password,
                sms_provider_type_code: this.state.sms_provider_type_code,
                // sms_provider_type_title: this.state.sms_provider_type_title,
                is_limit_sms_by_single_ip: this.state.is_limit_sms_by_single_ip,
                limit_sms_count_short: this.state.limit_sms_count_short,
                limit_sms_interval_min_short: this.state.limit_sms_interval_min_short,
                limit_sms_count_long: this.state.limit_sms_count_long,
                limit_sms_interval_min_long: this.state.limit_sms_interval_min_long,
                allow_registration_by_phone: this.state.allow_registration_by_phone
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Настройки SMS бренда изменены!");
            });
        }
    };
    BrandSmsCfgEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandSmsCfgEditor.prototype.getFormTitle = function () {
        return "Изменить настройки SMS бренда";
    };
    BrandSmsCfgEditor.prototype.getContent = function () {
        if (this.state.tab_key === this.key_main) {
            return this.getMainEditorContent();
        }
        if (this.state.tab_key === this.key_restrictions) {
            return this.getRestrictionsEditorContent();
        }
        return null;
    };
    BrandSmsCfgEditor.prototype.onDeleteClick = function (record) {
        this.props.dataRestrictions.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0435 sms \u0431\u044B\u043B\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u043E"));
        });
    };
    BrandSmsCfgEditor.prototype.onEditClick = function (record) {
        var _this = this;
        this.props.DlgSmsRestrictionEditor
            .SetActions(this.state._actions)
            .SetActionTitle(record.sms_action_type_title)
            .SetActionVal(record.sms_action_type_code)
            .SetBlockByMinutes(record.block_by_minutes)
            .SetCompletedAttemptsVal(record.completed_attempts_count)
            .SetIsLocked(record.is_locked)
            .SetDialogTitle("Изменить ограничение sms")
            .SetOnNoClick(function () { _this.props.DlgSmsRestrictionEditor.Close(); })
            .SetOnYesClick(function (actionVal, cAttemptsCnt, blockByMin, isLocked) {
            _this.props.dataRestrictions.EditData({
                key: record.key,
                sms_action_type_code: actionVal,
                completed_attempts_count: cAttemptsCnt,
                block_by_minutes: blockByMin,
                is_locked: isLocked
            }, function () {
                _this.props.dataRestrictions.LoadData(_this.props.record.key, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0435 sms \u0431\u044B\u043B\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u043E"));
                });
            });
        })
            .Show();
    };
    BrandSmsCfgEditor.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            //this.props.BonusTemplateCfgZones.LoadData(this.props.record.key);
            this.props.dataRestrictions.LoadData(this.props.record.key);
        }
        if (action === "create") {
            this.props.DlgSmsRestrictionEditor
                .SetActions(this.state._actions)
                // .SetActionTitle(this.state.)
                .SetDialogTitle("Добавить ограничение смс")
                .SetOnNoClick(function () { _this.props.DlgSmsRestrictionEditor.Close(); })
                .SetOnYesClick(function (actionVal, cAttemptsCnt, blockByMin, isLocked) {
                _this.props.dataRestrictions.AddData({
                    brand_id: _this.props.record.key,
                    block_by_minutes: blockByMin,
                    completed_attempts_count: cAttemptsCnt,
                    sms_action_type_code: actionVal,
                    is_locked: isLocked
                }, function () {
                    _this.props.dataRestrictions.LoadData(_this.props.record.key, function () {
                        notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0435 sms \u0431\u044B\u043B\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E"));
                    });
                });
            })
                .Show();
        }
    };
    BrandSmsCfgEditor.prototype.getRestrictionsEditorContent = function () {
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.restrictions_list, pagination: { pageSize: 7 }, scroll: { x: true } })));
    };
    BrandSmsCfgEditor.prototype.getMainEditorContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Url sms сервер:", placeholder: "Введите url sms сервера" }, value: this.state.sms_api_url, onValueChanged: function (newVal) {
                    _this.setState({
                        sms_api_url: newVal
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Api ключ :", placeholder: "Введите api ключ" }, value: this.state.sms_api_key, onValueChanged: function (newVal) {
                    _this.setState({
                        sms_api_key: newVal
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Логин :", placeholder: "Введите логин сервера" }, value: this.state.sms_login, onValueChanged: function (newVal) {
                    _this.setState({
                        sms_login: newVal
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Пароль :", placeholder: "Введите пароль сервера" }, value: this.state.sms_password, onValueChanged: function (newVal) {
                    _this.setState({
                        sms_password: newVal
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Провайдер SMS :", placeholder: "Выберите провайдера sms сообщений" }, value: { key: this.state.sms_provider_type_code, value: this.state.sms_provider_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        sms_provider_type_code: newVal.key,
                        sms_provider_type_title: newVal.value
                    });
                }, items: this.props.smsProvidersAvail, required: true, rules: this.state.sms_provider_type_rules, disabled: false }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Разрешать регистрацию по номеру телефона", value: this.state.allow_registration_by_phone, onChecked: function (checked) {
                    _this.setState({
                        allow_registration_by_phone: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: true, title: { btnEdit: "Сохранить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    BrandSmsCfgEditor.prototype.getTabsArray = function () {
        var _ret = [];
        _ret.push({ key: this.key_main, tab: "Основные" });
        _ret.push({ key: this.key_restrictions, tab: "Ограничения" });
        return _ret;
    };
    BrandSmsCfgEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 700, tabs: this.getTabsArray(), onTabChange: function (key) {
                _this.setState({
                    tab_key: key
                });
            }, activeTabKey: this.state.tab_key }, this.getContent()));
    };
    return BrandSmsCfgEditor;
}(React.Component));
exports.default = BrandSmsCfgEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/BrandSmsCfgEditor.tsx
// module id = 1852
// module chunks = 0